<div fxLayout="row" fxLayoutAlign="space-between center">
  <div
    fxLayoutAlign="start center"
    fxLayout="row"
    fxLayoutGap="20px"
    (click)="goBack()"
    class="link"
  >
    <div>
      <img src="assets/icons/left-arrow-icon.svg" alt="" />
    </div>
    <div class="equipment-id">
      <!-- Title -->
      <span class="ui grey">Home / Invoices & Payments</span>
      <h2 class="ui primary header">Invoices & Payments</h2>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button class="ui small button primary" (click)="toggleAdvancedSearch()">
      Advanced Search
    </button>
    <button class="ui small button primary" (click)="exportSearch()">
      Export
    </button>
  </div>
</div>

<div class="ui secondary pointing menu">
  <a
    class="item"
    routerLink="/contractor/invoice/list"
    routerLinkActive="active"
  >
    Invoices
  </a>
  <a
    class="item"
    routerLink="/contractor/invoice/payment"
    routerLinkActive="active"
  >
    Invoiced Payments
  </a>
  <a
    class="item"
    routerLink="/contractor/invoice/non-invoiced-payment"
    routerLinkActive="active"
  >
    Non-Invoiced Payments
  </a>
</div>
<div class="ui vertical segment">
  <router-outlet></router-outlet>
</div>
